module.exports = __webpack_public_path__ + "img/0347f1b.png";